import React, { Component } from 'react'
import { REACT_APP_ENV } from '../../env'
import { Button } from '../../components'
import { THEMES } from '../../utils'

import './login.page.scss'

/**
 * Login Component
 */
class Login extends Component {
  /**
   * Component did mount
   */
  componentDidMount () {
    this.handleAuthentication()
  }

  /**
   * Handle authentication
   * @returns {*}
   */
  handleAuthentication () {
    const { auth, history, location } = this.props

    if (auth.isAuthenticated()) {
      return history.push('/dashboard')
    }

    if (/access_token|id_token|error/.test(location.hash)) {
      return auth
        .handleAuthentication()
        .then(() => history.push('/dashboard'))
        .catch(() => history.replace('/'))
    }
  }

  /**
   * On login
   */
  onLogin () {
    const { auth } = this.props
    auth && auth.login()
  }

  /**
   * Render Login Component
   * @return {XML}
   */
  render () {
    return (
      <div className='login-page'>
        <div className='login-page_background' />
        <div className='login-page_content'>
          <div className='q4i-logo' />
          <div className='login-page_title'>Q4 Contact Admin</div>
          <Button
            className='button--blocked'
            theme={THEMES.CITRUS}
            label='Login using Google'
            onClick={this.onLogin.bind(this)} />
          <a
            className='login-page_button--support button--blocked button--transparent'
            href={`mailto:desktop@q4inc.com?Subject=Q4%20Contacts%20Admin%20-%20Login%20Support%20-%20${REACT_APP_ENV}`}>
            Unable to access your account?
          </a>
        </div>
      </div>
    )
  }
}

export default Login
